// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1DwpB","title":"ClientInsurance_title__2o-jZ","itemText":"ClientInsurance_itemText__S5P8Q"};